import React, { useEffect, useState, useRef } from "react";
import quizData from "../data/home.json";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import articleData from "../data/financeFacts.json";
import FactsSection from "../components/FactsSection";
import AdComponent from "../components/AdComponent";
import moment from "moment";
import notificationService from "../services/notificationService";

const Home = () => {
    const [groupedData, setGroupedData] = useState([]);
    const [categories, setCategories] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const swiperRef = useRef(null);
    const article = articleData?.PAGE5 || {};

    useEffect(() => {
        // Initialize Firebase notifications and request permission
        const initializeNotifications = async () => {
            // Check if notifications are supported
            if (!('Notification' in window)) {
                console.log('This browser does not support notifications');
                return;
            }

            console.log('Current notification permission:', Notification.permission);

            // Check current permission status
            if (Notification.permission === 'granted') {
                console.log('Notification permission already granted, initializing Firebase...');
                try {
                    const isInitialized = await notificationService.initialize();
                    if (isInitialized) {
                        console.log('Firebase notifications initialized successfully');
                    } else {
                        console.log('Failed to initialize Firebase notifications');
                    }
                } catch (error) {
                    console.error('Error initializing Firebase notifications:', error);
                }
            } else if (Notification.permission === 'default') {
                // Request permission after a delay to ensure page is loaded
                setTimeout(async () => {
                    try {
                        console.log('Requesting notification permission...');
                        const isInitialized = await notificationService.initialize();

                        if (isInitialized) {
                            console.log('Permission granted and Firebase notifications initialized');
                            // Show a test notification
                            // new Notification('Notifications Enabled!', {
                            //     body: 'You will now receive quiz updates and announcements.',
                            //     icon: '/logo.png'
                            // });
                        } else {
                            console.log('Permission denied or Firebase initialization failed');
                        }
                    } catch (error) {
                        console.error('Error requesting notification permission:', error);
                    }
                }, 2000);
            } else {
                console.log('Notification permission denied');
            }
        };

        initializeNotifications();
    }, []);

    useEffect(() => {

        const now = new Date();
        const currentTime = now.toTimeString().slice(0, 8);
        const filtered = quizData.filter(
            (c) => {
                return c.status === "live";
            }
        );
        setCategories(filtered);

        filtered.sort((a, b) => {
            if (a.topic_name < b.topic_name) return -1;
            if (a.topic_name > b.topic_name) return 1;
            return a.announcement_time.localeCompare(b.announcement_time);
        });

        const grouped = [];
        filtered.forEach((category) => {
            if (!grouped[category.topic_id]) {
                grouped[category.topic_id] = {
                    topic_name: category.topic_name,
                    categories: [],
                };
            }
            grouped[category.topic_id].categories.push(category);
        });

        setGroupedData(grouped);
    }, []);

    // Function to handle tab click and slide to the appropriate position
    const handleTabClick = (tabId, slideIndex) => {
        setActiveTab(tabId);

        // Slide to the clicked tab
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.slideTo(slideIndex, 300); // 300ms animation
        }
    };




    return (
        <>
            <AdComponent />
            {groupedData.length > 0 ? (
                <section className="game-tabs-section pt pb">
                    <div className="container">
                        <div className="tabs-wrapper">
                            <div className="d-flex align-items-center gap-2 mb-3">
                                <ul className="tabs">
                                    <Swiper
                                        ref={swiperRef}
                                        slidesPerView="auto"
                                        spaceBetween={10}
                                        loop={false}
                                        freeMode={true}
                                        breakpoints={{
                                            420: {
                                                slidesPerView: "auto",
                                                spaceBetween: 10,
                                            },
                                        }}
                                        className="quizTopicSwiper"
                                    >
                                        <SwiperSlide style={{ width: "auto" }} onClick={() => handleTabClick(0, 0)}>
                                            <li className={activeTab === 0 ? 'active' : ''} data-tab="all-contests">ALL CONTESTS</li>
                                        </SwiperSlide>

                                        {groupedData &&
                                            Object.entries(groupedData).map(([topicId, topicData], index) => (
                                                <SwiperSlide style={{ width: "auto" }} key={topicId} onClick={() => handleTabClick(topicId, index + 1)}>
                                                    <li className={activeTab === topicId ? 'active' : ''} data-tab={`topic-${topicId}`}>{topicData.topic_name.toUpperCase()}</li>
                                                </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </ul>

                                {/* Search */}
                                <Link to={"/quiz/search"} className="search-icon">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <path
                                            d="M16.893 16.92L19.973 20M19 11.5C19 13.4891 18.2098 15.3968 16.8033 16.8033C15.3968 18.2098 13.4891 19 11.5 19C9.51088 19 7.60322 18.2098 6.1967 16.8033C4.79018 15.3968 4 13.4891 4 11.5C4 9.51088 4.79018 7.60322 6.1967 6.1967C7.60322 4.79018 9.51088 4 11.5 4C13.4891 4 15.3968 4.79018 16.8033 6.1967C18.2098 7.60322 19 9.51088 19 11.5Z"
                                            stroke="white"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </Link>
                            </div>

                            <div className="tabs-container">
                                {/* All Contests */}
                                <div id="all-contests" className={`tab-content ${activeTab === 0 ? 'active' : ''}`}>
                                    <div className="game-card-wrp d-flex">
                                        {categories.map((category) => (
                                            <div
                                                className="game-card"
                                                key={category.id}
                                                data-category-id={category.id}
                                            >
                                                <div className="game-card-top">
                                                    <div className="game-icon">
                                                        <img
                                                            src={category.category_image}
                                                            alt={category.name}
                                                        />
                                                    </div>
                                                    <div className="game-info">
                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <span className="category">
                                                                {category.topic_name.toUpperCase()}
                                                            </span>
                                                            <div className="game-status">
                                                                <span className="loader"></span>
                                                                <span className="live-text">
                                                                    {category.status.toUpperCase()}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <h3>
                                                            Play and Win{" "}
                                                            {Number(category.winner_coins).toLocaleString()}
                                                            <span className="coin">
                                                                <img
                                                                    src="/assets/images/dollar.png"
                                                                    alt="coin"
                                                                />
                                                            </span>
                                                        </h3>
                                                        <p className="subtitle">
                                                            Winner announcement @
                                                            {category.announcement_time}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="game-card-bottom">
                                                    <p className="entry">
                                                        Entry:{" "}
                                                        {category.entry_fee > 0 ? (
                                                            <b>{category.entry_fee}</b>
                                                        ) : (
                                                            <b>Free</b>
                                                        )}{" "}
                                                        Coins
                                                        <span className="coin">
                                                            <img src="/assets/images/dollar.png" alt="coin" />
                                                        </span>
                                                        <b>{category.total_participants}</b> Users Playing
                                                    </p>
                                                    <Link
                                                        to={`/join-contest/${category.id}`}
                                                        className="play-btn btn"
                                                    >
                                                        PLAY
                                                    </Link>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Dynamic Topic Tabs */}
                                {Object.entries(groupedData).map(([topicId, topicData]) => (
                                        <div
                                            id={`topic-${topicId}`}
                                            className={`tab-content ${activeTab === topicId ? 'active' : ''}`}
                                            key={topicId}
                                        >
                                            <div className="game-card-wrp d-flex">
                                                {topicData.categories.map((category) => (
                                                    <div
                                                        className="game-card"
                                                        key={category.id}
                                                        data-category-id={category.id}
                                                    >
                                                        <div className="game-card-top">
                                                            <div className="game-icon">
                                                                <img
                                                                    src={category.category_image}
                                                                    alt={category.name}
                                                                />
                                                            </div>
                                                            <div className="game-info">
                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <span className="category">
                                                                        {category.topic_name.toUpperCase()}
                                                                    </span>
                                                                    <div className="game-status">
                                                                        <span className="loader"></span>
                                                                        <span className="live-text">
                                                                            {category.status.toUpperCase()}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <h3>
                                                                    Play and Win{" "}
                                                                    {Number(
                                                                        category.winner_coins
                                                                    ).toLocaleString()}
                                                                    <span className="coin">
                                                                        <img
                                                                            src="/assets/images/dollar.png"
                                                                            alt="coin"
                                                                        />
                                                                    </span>
                                                                </h3>
                                                                <p className="subtitle">
                                                                    Winner announcement @
                                                                    { category.announcement_time }
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="game-card-bottom">
                                                            <p className="entry">
                                                                Entry:{" "}
                                                                {category.entry_fee > 0 ? (
                                                                    <b>{category.entry_fee}</b>
                                                                ) : (
                                                                    <b>Free</b>
                                                                )}{" "}
                                                                Coins
                                                                <span className="coin">
                                                                    <img
                                                                        src="/assets/images/dollar.png"
                                                                        alt="coin"
                                                                    />
                                                                </span>
                                                                <b>{category.total_participants}</b> Users
                                                                Playing
                                                            </p>
                                                            <Link
                                                                to={`/join-contest/${category.id}`}
                                                                className="play-btn btn"
                                                            >
                                                                PLAY
                                                            </Link>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
            ) : (
                <div className="text-center py-5">
                    <i className="fas fa-calendar-times fa-3x text-muted mb-3"></i>
                    <h4>No Live Quizzes Available</h4>
                    <p>New quizzes will be available soon. Check back later!</p>
                </div>
            )}

            {/* Inline styles can go to CSS */}
            <style>{`
                .hero-section {
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                }

                .quiz-card {
                    transition: transform 0.2s ease-in-out;
                }

                .quiz-card:hover {
                    transform: translateY(-5px);
                }

                .bg-gradient-primary {
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                }

                .user-statistics .card {
                    background-color: var(--card-bg) !important;
                }

                .user-statistics .text-muted {
                    color: #ffffff !important;
                }

            `}</style>
            <section className="facts-section">
                <div className="container">
                    <div className="finance-fact">
                        <h2 className="fw-bold mb-4">{article?.title}</h2>
                    </div>
                    {
                        article?.content?.map((item, index) => (
                            <FactsSection key={index} item={item} />
                        ))
                    }
                    <div className="article-card">
                        <h2 className="article-card-title">{article?.action?.title}</h2>
                        
                        <p className="article-card-desc">
                            <strong className="desc-color">{article?.action?.title1}</strong> {article?.action?.desc1}
                        </p>
                        
                        <p className="article-card-desc">
                            <strong className="desc-color">{article?.action?.title2}</strong> {article?.action?.desc2}
                        </p>
                        
                        <p className="article-card-desc">
                            {
                                article?.action?.list.map((list, index) => (
                                    <>{list}<br /></>
                                ))
                            }
                        </p>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Home